import { cva } from 'class-variance-authority'

export const toggleStyle = cva(
  `
    inline-flex
    items-center
    justify-center
    gap-2
    h-7
    px-3
    py-2
    rounded-2xl
    text-sm
    font-medium
    text-neutral-500
    shadow-xs
    border-1
    border-dashed
    border-neutral-200
    transition-[background-color] duration-150 ease-in-out
    hover:bg-neutral-0
    hover:border-neutral-300
    active:bg-neutral-25
    focus-visible:outline-none
    focus-visible:ring-1
    focus-visible:ring-ring
    disabled:pointer-events-none
    disabled:opacity-50
    data-[state=on]:border-solid
    data-[state=on]:border-green-50
    data-[state=on]:active:bg-green-25
    data-[state=on]:text-green-100
    data-[state=on]:hover:border-green-100
    data-[state=on]:bg-green-0
    disabled:bg-neutral-50
    disabled:text-neutral-700
    [&_svg]:pointer-events-none
    [&_svg]:size-4
    [&_svg]:shrink-0
  `
)
